import React from 'react';
import { Check, Image as ImageIcon } from 'lucide-react';

// Photo strip of a list's pieces with jewellery numbers; tick to select when onToggle is given.
export function TagThumbStrip({ items, thumbs, selected, onToggle, testid }) {
  return (
    <div className="grid grid-cols-[repeat(auto-fill,minmax(96px,1fr))] gap-2" data-testid={testid}>
      {items.map((i) => {
        const on = selected?.has(i.id);
        const url = thumbs?.get(i.id);
        const Tag = onToggle && !i.returned ? 'button' : 'div';
        return (
          <Tag key={i.id} type={Tag === 'button' ? 'button' : undefined} onClick={Tag === 'button' ? () => onToggle(i.id) : undefined}
            className={`group relative overflow-hidden rounded-xl border bg-background text-left transition-all ${on ? 'border-emerald-600 ring-2 ring-emerald-600/40' : 'border-border'} ${Tag === 'button' ? 'hover:-translate-y-0.5 hover:shadow-md' : ''} ${i.returned ? 'opacity-40' : ''}`} data-testid={`${testid}-thumb`}>
            <div className="grid aspect-square place-items-center bg-secondary/40">{url ? <img src={url} alt={i.jewellery_no} className="h-full w-full object-contain p-1.5" /> : <ImageIcon size={18} className="text-muted-foreground" />}</div>
            <div className="truncate px-1.5 py-1 text-center font-mono text-[length:calc(var(--fs,1)*0.65625rem)] font-semibold text-emerald-700">{i.jewellery_no}</div>
            {onToggle && !i.returned ? <span className={`absolute left-1.5 top-1.5 grid h-5 w-5 place-items-center rounded-md border ${on ? 'border-emerald-600 bg-emerald-600 text-white' : 'border-border bg-background/90 text-transparent'}`}><Check size={12} /></span> : null}
          </Tag>
        );
      })}
    </div>
  );
}
